import { useState } from 'react';
import { useQuery } from 'data-fetching-client';

// @ts-expect-error Untyped
import Doc from 'developer-docs-shared-components/modules/Doc/components/Doc';

// @ts-expect-error Untyped
import { getFilteredOasDocs } from 'developer-docs-shared-components/modules/Doc/selectors/DocSelectors';
import { useAppDispatch, useAppSelector } from '../../reducers';
import { FETCH_SPECIFICATION } from '../../queries/swaggerQueries';
import { getUsageTracker } from '../../utils/usage-tracker';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const SwaggerEndpoint = ({
  endpoint,
  path,
  method
}) => {
  const dispatch = useAppDispatch();
  const {
    loading,
    error,
    data: __data
  } = useQuery(FETCH_SPECIFICATION, {
    variables: {
      dispatch,
      endpoint
    },
    // TODO: Temporary fix due to how the Doc component depends on the redux store
    // The fetcher here is what puts the result into the store; however if the cache
    // is hit, this process is missed (stale data when reviewing content you've
    // already loaded). Pulling the dispatch outside of the useQuery results in
    // a race condition where we try to render something based on a given doc ID
    // but then that id changes as part of the dispatch causing runtime errors.
    // Probably easiest to fix this as part of avoiding the redux store parts
    // entirely
    fetchPolicy: 'no-cache'
  });

  // TODO: Would need to be local storage tied
  const [language, setLanguage] = useState('curl');

  // TODO: any
  const filteredOasDocs = useAppSelector(getFilteredOasDocs) || [];
  if (loading) {
    return /*#__PURE__*/_jsx("div", {
      children: "Loading..."
    });
  }
  if (error) {
    return /*#__PURE__*/_jsxs("div", {
      children: ["Error! ", error.message]
    });
  }

  // Little weird. Lookup the right doc based on path/method
  const doc = filteredOasDocs.find(oasDoc => oasDoc.swagger.path === path && oasDoc.api.method === method);
  return /*#__PURE__*/_jsx("div", {
    children: doc ? /*#__PURE__*/_jsx(Doc, {
      doc: doc,
      oasDocs: filteredOasDocs,
      setLanguage: setLanguage,
      language: language,
      usageTracker: getUsageTracker()
    }, doc._id) : null
  });
};
export default SwaggerEndpoint;